var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.11 73.21C5.41 65.1 2.47 62.1.88 57.34s-1.59-9.52 4.76-12.7 7.94-1.59 11.11 7.94S23.1 86.01 33.5 66.67C38.93 56.59 68.43 12.7 76.37 6.35S90.65 0 93.83 0c3.17 0 11.11 0-3.17 12.7 0 0-52.38 68.25-58.73 82.54 0 0-3.17 4.76-7.94 4.76S12.87 87.5 8.11 73.21z","fill":"currentColor"}));
}

Check.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Check;

Check.default = Check;
